import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
//import LifeMemoryCareimg from '../assets/images/service-page/life-memory-care.png' 

function WhatMemoryCare({data}) {
  return (
    <> 
    <section className="memory-care bg-light-primary">
      <Container>
        <Row className="align-items-center">             
          <Col sm="12" md="6" className='mb-4 mb-md-0'>    
            <div className="memory-care-box">        
              <div dangerouslySetInnerHTML={{ __html: data?.title }}></div>
              <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>  
            </div>
          </Col>
          <Col sm="12" md="6">
            <img className="memory-care-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data?.image}`} alt={data?.title} />
          </Col> 
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default WhatMemoryCare